import React from 'react'
import { Link } from 'react-router'
import img from '../../../public/mm-logo.png'
import navigationConfig from '../../configs/section-config'

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%'
  }
};

const NavLabels = () => {
    const filteredNavItems = Object.keys(navigationConfig).filter(key => {
      return !navigationConfig[key].omitInTabs
    })

    const navItems = filteredNavItems.map(key => {
      const {path, title} = navigationConfig[key];
      return (
        <div 
          className='nav-labels'
          key={key}
        >
          <Link to={path} activeClassName='active'>
            <p>{title.toUpperCase()}</p>
          </Link>
        </div>
      )
    });

    return (
      <div style={styles.root}>
        <Link to='/'>
          <img className='logo' src={img} alt='Mind Makers'/>
        </Link>
        {navItems}
      </div>
    );
}

export default NavLabels


// WEBPACK FOOTER //
// ./src/components/NavBar/NavLabels.js